import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import useOnboardingContext from '@/hooks/useOnboardingContext'
import Layout from './views'

const ShampooConditionerHeader = () => {
  const { template } = useTemplateContext()
  const { classicMenu, sections } = useOnboardingContext()
  const defaultMenuOptions = ['header_and_introduction', 'footer']
  const onlyDefaultMenuOptionsEnabled = Object.entries(sections).every(
    ([key, value]) =>
      (defaultMenuOptions.includes(key) && value === true) || 
      (!defaultMenuOptions.includes(key) && value === false)
  )

  return (
    <>
      <Layout.Header textColor="textSecondary" backgroundColor="secondary">
        <CommonComponents.Wrapper height="70px">
          <Layout.HeaderContainer>
            <Layout.Logo>
              {template.logo.src ? (
                <Layout.LogoImage src={template.logo.src} />
              ) : (
                <Layout.LogoText fontFamily={template.logo.fontFamily}>
                  {template.logo.text}
                </Layout.LogoText>
              )}
            </Layout.Logo>
            {template.sections?.navigation?.hasShoppingCart && <Layout.Navigation textColor="textPrimary" hasShoppingCart={template.sections.navigation.hasShoppingCart} />}
          </Layout.HeaderContainer>
        </CommonComponents.Wrapper>
      </Layout.Header>
      {(!onlyDefaultMenuOptionsEnabled)
        ? <Layout.Menu backgroundColor="primary" activeTextColor="complementary" textColor="accent" menu={classicMenu} sections={sections} />
        : <Layout.SubHeader>
            <Layout.SubHeaderTitle>{template.sections.header?.title}</Layout.SubHeaderTitle>
          </Layout.SubHeader>
      }
    </>
  )
}

export default ShampooConditionerHeader
